module.exports = __webpack_public_path__ + "img/banner.ad34b1b3.png";